module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-error-eb822e3cb964256583bcd53e584d2676.svg";